import { useRuntimeConfig } from '#imports'
import type { RouteRecordRaw } from 'vue-router'

import { GUEST } from './route-names'

export default (): RouteRecordRaw[] => {
  const { FF_ENABLE_GUEST_MY_ORDERS } = useRuntimeConfig().public

  return [
    {
      name: GUEST.ORDERS,
      path: 'guest/orders',
      component: () =>
        import('~/scopes/guest/pages/guest-orders/GuestOrders.vue'),
      meta: {
        owners: ['bot-squad-sales-customer-care-front'],
        routeExists: () => FF_ENABLE_GUEST_MY_ORDERS === true,
        auth: {
          mode: 'guest-magic-link',
          redirection: { name: GUEST.UPGRADE_RESEND_LINK },
        },
        tracking: { contentGroup: 'Account' },
        shoppingAssistant: { enabled: false },
      },
    },
    {
      name: GUEST.UPGRADE,
      path: 'guest/upgrade',
      component: () =>
        import('~/scopes/guest/pages/guest-upgrade/GuestUpgrade.vue'),
      meta: {
        auth: {
          mode: 'guest-magic-link',
          redirection: { name: GUEST.UPGRADE_RESEND_LINK },
        },
        layout: 'minimal',
        owners: ['bot-squad-identity'],
        userLoadingStrategy: 'never',
        tracking: { contentGroup: 'Account' },
        shoppingAssistant: { enabled: false },
      },
    },
    {
      name: GUEST.UPGRADE_RESEND_LINK,
      path: 'guest/upgrade/resend-link',
      component: () =>
        import('~/scopes/guest/pages/guest-upgrade-resend-link/GuestUpgradeResendLink.vue'),
      meta: {
        layout: 'minimal',
        owners: ['bot-squad-identity'],
        tracking: { contentGroup: 'Account' },
        shoppingAssistant: { enabled: false },
      },
    },
  ]
}
